import { create } from 'zustand';

const loadFromStorage = () => {
    try {
        const json = localStorage.getItem('uiPreferences');
        return json ? JSON.parse(json) : {};
    } catch {
        return {};
    }
};

const saved = loadFromStorage();

export const useUIStore = create((set) => ({
    serviceLayout: saved.serviceLayout || 'grid',
    categoryLayout: saved.categoryLayout || 'sidebar',

    setServiceLayout: (layout) => {
        set({ serviceLayout: layout });
        try {
            const current = loadFromStorage();
            localStorage.setItem('uiPreferences', JSON.stringify({ ...current, serviceLayout: layout }));
        } catch {}
    },

    setCategoryLayout: (layout) => {
        set({ categoryLayout: layout });
        try {
            const current = loadFromStorage();
            localStorage.setItem('uiPreferences', JSON.stringify({ ...current, categoryLayout: layout }));
        } catch {}
    },
}));
